/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockMoveBackIcon16Light = forwardRef('TimeClockMoveBackIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.535 2.098A5.5 5.5 0 0 0 2.6 5H4.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5V2.252a.5.5 0 1 1 1 0v1.784a6.5 6.5 0 1 1-.629 5.63.5.5 0 0 1 .943-.333 5.5 5.5 0 1 0 6.22-7.235Z" }),
        React.createElement("path", { d: "M7.5 3.902a.5.5 0 0 1 .5.5v2.325c0 .284.16.544.415.671l2.309 1.155a.5.5 0 0 1-.448.894L7.967 8.293A1.75 1.75 0 0 1 7 6.727V4.402a.5.5 0 0 1 .5-.5Z" })));
});
